import { getData, postData, putData } from '../services/api';

export const getRooms = () => {
    return getData('/api/chat/rooms');
};

export const getOrCreateDirectRoom = (recipientId) => {
    return postData('/api/chat/rooms/direct', { recipientId });
};

export const getRoomMessages = (roomId, before = null) => {
    let url = `/api/chat/rooms/${roomId}/messages`;
    if (before) url += `?before=${before}`;
    return getData(url);
};

export const sendMessage = (roomId, content, type = 'text', replyToId = null, mediaUrl = null) => {
    return postData(`/api/chat/rooms/${roomId}/messages`, { content, type, replyToId, mediaUrl });
};

export const markRoomAsRead = (roomId) => {
    return putData(`/api/chat/rooms/${roomId}/read`, {});
};
